import type { ProductCart } from '@models';

/**
 * Apple lines behave differently across the cart: each unit occupies its own line (quantity 1)
 * and its tile has no quantity stepper, which several FCR 19.1 order-limit rules depend on.
 * Single source for the brand check, previously duplicated across the cart components.
 */
export const isAppleBrand = (product: Pick<ProductCart, 'brandName'> | null | undefined): boolean =>
  product?.brandName?.toLowerCase() === 'apple';
